import React, { useContext, useEffect, useState } from "react";
import { Tabs, Tab, Nav, Modal, Button, Table, Form } from "react-bootstrap";
import settingw from "../../assets/setting-white.svg";
import docGrey from "../../assets/doc-grey.svg";
import downloadImg from "../../assets/download.svg";
import backImg from "../../assets/back.svg";
import deleteImageEnabled from "../../assets/reddelete.svg";
import { processType } from "../../utils/constant";
import {
  getRFQById,
  handleDeclineRFQ,
  submitRFQ,
  getRFQByRFQRefId,
  uploadRFQDocument,
  deleteRFQDocument,
  downloadBatchFile,
  getRFQByRFQId,
} from "../../utils/actions/userActions";
import { Link, useNavigate, useParams, Redirect } from "react-router-dom";
import {
  downloadFileFromS3,
  extractURLAndEncodedFilename,
  numberInputOnWheelPreventChange,
  validateUser,
} from "../../utils/helper";
import { toast } from "react-toastify";
import moment from "moment";
import HoverInfo from "../../component/HoverInfo/HoverInfo";
import { OrdersContext } from "../../context/orders.context";
import ChatButton from "../../component/Chat/ChatButton";
import Chat from "../../component/Chat";
import qs from "query-string";
import CurrencyFormat from "../../component/CurrencyFormat";
import { Loading } from "../../component/Loading";
import { DeleteIcon, DownloadIcon } from "../../component/icons";
import MetaDataThreeDComponent from "../../component/MetaDataComponents/MetaDataThreeDComponent";
import MetaDataCncComponent from "../../component/MetaDataComponents/MetaDataCncComponent";
import { getAllMaterialsList, getAllTechnology, getPresignedUrlForFile } from "../../helperApi/helperApi";
import ThreeDViewerComponent from "../../component/ThreeDViewerComponent/ThreeDViewerComponent";
import { ChatRefContext } from "../../context/chatRef.context";
import FileName from "../../component/FileName";
import PDFModalViewer from "../../component/PDFViewerModal/PDFModalViewer";
import { Modal as AntModal } from "antd";
import DimensionsDisplay from "../../component/DimensionDisplay/DimensionDisplay";



const RFQDetails = () => {
  const loggedInUserToken = localStorage.getItem("Token");
  const [isValidUser, setIsValidUser] = useState(true);
  const [selectedRFQ, setSelectedRFQ] = useState({});
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showReviewQuoteModal, setShowReviewQuoteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { search } = window.location;
  const param = qs.parse(search);
  const navigate = useNavigate();
  const [open, setOpen] = useState(param.chat);
  const [isSubmitQuoteLoading, setIsSubmitQuoteLoading] = useState(false);
  const {
    refresh,
    setRefresh,
    activeTab,
  } = useContext(OrdersContext);
  let { selectedChatRefId, setSelectedChatRefId, chatType } = useContext(ChatRefContext);
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  let userId = localStorage.getItem("_id");
  let email = localStorage.getItem("email");
  const [allData, setAllData] = useState([]);
  const [masterThreeDTechnologyData, setMasterThreeDTechnologyData] = useState([]);
  const [pdfModalInfo, setPdfModalInfo] = useState({
    show: false,
    fileName: '',
    pdfUrl: ''
  });
  useEffect(() => {
    (async () => {
      try {
        const data = await getAllTechnology();

        if (data?.success) {
          setMasterThreeDTechnologyData(data?.data);
        }

      } catch (error) {
        console.error(error);
      }
      finally {
      }
    })()

  }, []);
  useEffect(() => {
    (async () => {
      try {
        const data = await getAllMaterialsList();
        setAllData(data);
      } catch (error) {
        throw new Error("Unable To fetch All Material Data ");
      }
      finally {
      }
    })()

  }, []);

  useEffect(() => {
    let isLoggedInUser = validateUser(navigate);
    if (isLoggedInUser) {
      if (id) {
        setLoading(true);
        fetchData();
      }
    }
  }, []);

  const fetchData = async () => {
    try {
      const response = await getRFQByRFQId(id, loggedInUserToken);
      console.log("Dataf :", response);
      if (response.status) {
        setSelectedRFQ(response.data);
        if (
          response.data.status == "Cancelled" ||
          response.data.status == "Active Order"
        ) {
          setShowRedirectModal(true);
        }
      } else {

        toast.error(
          "Quotation data not found.Please contact us at admin to resolve the issue."
        );
        navigate("/my-orders");
        return;
      }

      let supplierLoggedIn = localStorage.getItem("supplierId");
      if (!supplierLoggedIn) {
        toast.error(
          "Something went wrong with loggedIn Credentials.Please login again."
        );
      } else {
        if (supplierLoggedIn != response.data.supplierId._id) {
          setIsValidUser(false);
        }
      }

      setLoading(false);
    } catch (err) {
      console.log("err", err);
      setLoading(false);
      toast.error("Something went wrong");
    }
  };


  const handleBatchDownloadClick = async () => {
    try {
      setLoading(true);
      const response = await downloadBatchFile(selectedRFQ?._id, 'supplier-rfq-offer');
      const blob = new Blob([response], { type: 'application/zip' });
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `batch_download_${selectedRFQ?.type || ""}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);



    } catch (error) {
      toast.error('Failed to download batch file at the moment');
    } finally {
      setLoading(false);
    }

  }

  const handleDeclineRFQClick = async () => {
    try {
      const userResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Decline Quotation',
          content: 'Are you sure you want to decline this quotation?',
          okText: 'Yes, Decline',
          cancelText: 'No',
          okType: 'danger', // highlights this as a destructive action
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!userResponse) return;
      let data = {
        rfqOfferId: selectedRFQ._id,
        isDeclined: true,
        declineReason: selectedRFQ.declineReason,
        declineDescription: selectedRFQ.declineDescription,
      };

      let response = await handleDeclineRFQ(data, loggedInUserToken);
      if (response.status) {
        toast.success(response.message);
        navigate("/my-orders?status=pending-for-quotation");
      } else {
        toast.error(response.message);
      }

    } catch (err) {
      console.log("err", err);
    }
  };

  const handleItemNotesChage = (event, index) => {
    let localPartsData = [...selectedRFQ.partsData];
    localPartsData[index].notes = event.target.value;

    setSelectedRFQ({ ...selectedRFQ, partsData: localPartsData });
  };

  const handleItemPriceChange = (event, index) => {
    let localPartsData = [...selectedRFQ.partsData];
    localPartsData[index].price = event.target.value;
    let totalPrice = localPartsData?.reduce((acc, item) => {
      return acc + item.price * item.qty;
    }, 0);

    setSelectedRFQ({
      ...selectedRFQ,
      partsData: localPartsData,
      price: totalPrice,
    });
  };

  const validateRFQData = () => {
    let isDataValid = true;
    let isPriceAvailable = false;

    for (let i = 0; i < selectedRFQ.partsData.length; i++) {
      if (selectedRFQ.partsData[i].price > 0) {
        isPriceAvailable = true;
        break;
      }
    }

    if (isPriceAvailable) {
      isDataValid = true;
    } else {
      isDataValid = false;
    }

    if (!selectedRFQ.leadTime) {
      isDataValid = false;
    }

    return isDataValid;
  };

  const handleSubmitQuote = async () => {
    setShowReviewQuoteModal(true);
    setIsSubmitQuoteLoading(true);
    try {
      const isValidData = validateRFQData();
      if (isValidData) {
        let response = await submitRFQ(selectedRFQ, loggedInUserToken);
        if (response.status) {
          toast.success(response.message);
          if (activeTab) {
            navigate(`/my-orders?status=${activeTab}`);
          } else {
            navigate(`/my-orders`);
          }

          setRefresh(refresh + 1);
        } else {
          toast.error(response.message);
        }
      } else {
        toast.error("Item price and delivery date are required field.");
        return;
      }
    } catch (err) {
      console.log("err", err);
    }
    finally {
      setLoading(false);
      setShowReviewQuoteModal(false);

      setIsSubmitQuoteLoading(false);
    }
  };

  const handleRfqDisableState = () => {
    console.log("Status :", selectedRFQ.status);
    const validState = ['Pending for Quotation', 'Under Review'];
    return selectedRFQ.status && !validState.includes(selectedRFQ.status);
  }

  const handleLeadTimeChange = (e) => {
    setSelectedRFQ({ ...selectedRFQ, leadTime: e.target.value });
  };

  const showDrawer = () => {
    console.log("selectedRFQ.supplierRFQRefId ::", selectedRFQ.supplierRFQRefId);
    setOpen(true);
    setSelectedChatRefId(selectedRFQ.supplierRFQRefId);
  };

  const onClose = () => {
    setOpen(false);
    setSelectedChatRefId(null);
  };

  const handleUploadRFQDocument = async (e) => {
    try {
      let rfqOfferDocument = e.target.files[0];
      let formData = new FormData();
      formData.append("rfqOfferId", selectedRFQ._id);
      formData.append("rfqOfferDocument", rfqOfferDocument);

      const uploadRFQDocResponse = await uploadRFQDocument(
        loggedInUserToken,
        formData
      );
      if (uploadRFQDocResponse.status) {
        toast.success("Document uploaded");
        setSelectedRFQ({
          ...selectedRFQ,
          rfqOfferDocument: uploadRFQDocResponse?.data?.rfqOfferDocument,
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleRFQDocumentDelete = async () => {
    try {
      const deleteDocResponse = await deleteRFQDocument(
        loggedInUserToken,
        selectedRFQ._id
      );
      if (deleteDocResponse.data.status) {
        setSelectedRFQ({ ...selectedRFQ, rfqOfferDocument: null });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const RedirectComponent = () => {
    const [countdown, setCountdown] = useState(3);

    useEffect(() => {
      const timer = setTimeout(() => {
        navigate("/my-orders");
      }, countdown * 1000);

      return () => clearTimeout(timer);
    }, [countdown, navigate]);

    useEffect(() => {
      if (countdown > 0) {
        const countdownTimer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        return () => clearInterval(countdownTimer);
      }
    }, [countdown]);

    return <div>Redirecting in {countdown} seconds...</div>;
  };
  console.log("Selected quote ::", selectedRFQ);
  return (
    <div className="content-wrapper">
      <Chat
        RefId={selectedRFQ.supplierRFQRefId}
        open={open}
        onDrawerClose={onClose}
      />
      <PDFModalViewer
        show={pdfModalInfo.show}
        handleClose={() => setPdfModalInfo({ show: false, fileName: '', pdfUrl: '' })}
        fileName={pdfModalInfo.fileName}
        pdfUrl={pdfModalInfo.pdfUrl}
      />
      {selectedRFQ !== "Under Review" && (
        <Modal
          size="lg"
          dialogClassName="qoute-version-modal"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showDeclineModal}
          onHide={() => setShowDeclineModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="text-2xl font-bold"
            >
              Decline Quotation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="issue-description-div">
              <div>
                <h6>Select a reason to decline</h6>
                <select
                  style={{ width: "40%", color: "#333333" }}
                  className="border outline-none  p-1"
                  defaultValue={selectedRFQ.declineReason}
                  onChange={(e) =>
                    setSelectedRFQ({
                      ...selectedRFQ,
                      declineReason: e.target.value,
                    })
                  }
                >
                  <option value="Capacity constraints">
                    Capacity constraints
                  </option>
                  <option value="Not feasible">Not feasible</option>
                  <option value="Low order quantity">Low order quantity</option>
                  <option value="Materials issues">Materials issues</option>
                  <option value="Capability issues">Capability issues</option>
                  <option value="Others">Others</option>
                </select>
              </div>
              <br />
              <div className="issue-description">
                <h6>Description:</h6>
                <textarea
                  className="border p-2 outline-none"
                  placeholder="Write description here"
                  value={selectedRFQ.declineDescription}
                  onChange={(e) =>
                    setSelectedRFQ({
                      ...selectedRFQ,
                      declineDescription: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div style={{ color: "#8b8b8b" }}></div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="white-btn"
              style={{ color: "red", fontWeight: "500" }}
              onClick={handleDeclineRFQClick}
            >
              Decline
            </button>
            <button
              className="white-btn"
              style={{ backgroundColor: "#2b96dc", color: "#fff" }}
              onClick={() => setShowDeclineModal(false)}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      )}

      <Modal
        size="lg"
        dialogClassName="!max-w-[90vw] !w-[90vw] mx-auto"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        show={showReviewQuoteModal}
        onHide={() => setShowReviewQuoteModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
          >
            Review Quotation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="version-tabs" style={{ overflowX: "auto" }}>
            <table className="qoute-version-table">
              <thead>
                <tr className="heading-row">
                  <th scope="col" className="w-40">Snapshot</th>
                  <th scope="col" className="w-44">Files</th>
                  <th scope="col" className="w-44">Description</th>
                  <th scope="col" className="w-48 ">Notes</th>
                  <th scope="col" className="w-32 ">Unit Price</th>
                  <th scope="col" className="w-20 ">Qty</th>
                  <th scope="col" className="w-32 ">Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectedRFQ?.partsData?.length > 0 &&
                  selectedRFQ.partsData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td >
                          <p className="text-sm bold text-center ~!h-28">
                            <ThreeDViewerComponent
                              item={item}
                              selectedProcess={selectedRFQ?.rfqOfferId?.selectedProcess}
                              additionalClasses={'!border-0'}

                            />
                          </p>
                        </td>
                        <td
                          style={{
                            wordWrap: "break-word",
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                            minWidth: "120px",
                          }}
                        >
                          <div className="text-primaryColor">

                            {item.selectedFile?.originalname ? (
                              <div className="inline-block">
                                <FileName
                                  fileName={item.selectedFile?.originalname}
                                  onDownload={async () => {
                                    const { originalname } = item?.selectedFile;
                                    if (originalname && originalname.endsWith('.pdf')) {
                                      const signedUrl = await getPresignedUrlForFile(item?.selectedFile.bucket, item?.selectedFile.key);
                                      console.log('Signed URL for PDF:', signedUrl);
                                      setPdfModalInfo({
                                        show: true,
                                        pdfUrl: signedUrl,
                                        fileName: originalname,
                                      })
                                      return;
                                    }
                                    await downloadFileFromS3(item?.selectedFile)
                                  }}
                                />
                                <DimensionsDisplay
                                  item={item}
                                />
                              </div>
                            ) : (
                              "File Not Available"
                            )}

                          </div>
                          <div className="text-primaryColor">
                            {item.twoDFile?.originalname ? (
                              <div className="inline-block">
                                <FileName
                                  fileName={item.twoDFile?.originalname}
                                  onDownload={async () => {
                                    const { originalname } = item?.twoDFile;
                                    if (originalname && originalname.endsWith('.pdf')) {
                                      const signedUrl = await getPresignedUrlForFile(item?.twoDFile.bucket, item?.twoDFile.key);
                                      console.log('Signed URL for PDF:', signedUrl);
                                      setPdfModalInfo({
                                        show: true,
                                        pdfUrl: signedUrl,
                                        fileName: originalname,
                                      })
                                      return;
                                    }
                                    await downloadFileFromS3(item?.twoDFile)
                                  }}
                                />
                                <DimensionsDisplay
                                  item={item}
                                />
                              </div>
                            ) : (
                              "File Not Available"
                            )}
                          </div>
                        </td>
                        <td style={{ minWidth: "250px" }}>
                          {selectedRFQ?.rfqOfferId?.selectedProcess >= 3 ? (
                            <>{item.description}</>
                          ) : (
                            <div>
                              {
                                selectedRFQ?.rfqOfferId?.selectedProcess == 1 ?
                                  <MetaDataCncComponent allData={allData} item={item} /> : null

                              }
                              {
                                selectedRFQ?.rfqOfferId?.selectedProcess == 2 ?
                                  <MetaDataThreeDComponent masterThreeDTechnologyData={masterThreeDTechnologyData} item={item} /> : null
                              }
                            </div>
                          )}
                        </td>
                        <td style={{ maxWidth: "240px" }}>
                          <p>
                            {item?.notes.length > 200
                              ? item?.notes.slice(0, 200) + "..."
                              : item.notes}
                          </p>
                        </td>
                        <td>
                          <p>
                            {" "}
                            <CurrencyFormat
                              amount={Number(item?.price).toFixed(2)}
                            />
                          </p>
                        </td>
                        <td>
                          <p className="amt text-center">{item?.qty}</p>{" "}
                        </td>
                        <td>
                          {" "}
                          <div className="amt">
                            <p className="un-fld">
                              <CurrencyFormat
                                amount={Number(item.qty * item.price).toFixed(
                                  2
                                )}
                              />
                            </p>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="border pe-20"
            >
              <div
                className="total-amount-order"
                style={{ padding: "10px 10px" }}
              >
                <h6 className="order-price">
                  Lead Time (in Days) :{selectedRFQ.leadTime + " days"}
                </h6>
              </div>
              <div
                className="total-amount-order"
                style={{ padding: "10px 10px" }}
              >
                <h6 className="order-price">
                  Total :
                  {selectedRFQ.price ? (
                    <CurrencyFormat
                      amount={Number(selectedRFQ.price).toFixed(2)}
                    />
                  ) : (
                    "0"
                  )}
                </h6>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="white-btn"
            style={{ color: "red", fontWeight: "500" }}
            onClick={() => setShowReviewQuoteModal(false)}
            disabled={isSubmitQuoteLoading}
          >
            Edit
          </button>
          <button
            className="white-btn"
            style={{
              backgroundColor: isSubmitQuoteLoading ? "#999" : "#2b96dc",
              color: "#fff",
              cursor: isSubmitQuoteLoading ? "not-allowed" : "pointer",
            }}
            onClick={handleSubmitQuote}
            disabled={isSubmitQuoteLoading}
          >
            {isSubmitQuoteLoading
              ? "Processing..."
              : selectedRFQ.status === "Under Review"
                ? "Update Quotation"
                : "Submit Quotation"}
          </button>

        </Modal.Footer>
      </Modal>

      <Modal
        size="lg"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showRedirectModal}
        onHide={() => {
          navigate(`/my-orders`);
          setShowRedirectModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
          >
            Quotation is already processed.
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <h6>Quotation for this reference Id is already processed.</h6>
              <RedirectComponent />
            </div>
            <br />
          </div>
          <div style={{ color: "#8b8b8b" }}></div>
        </Modal.Body>
      </Modal>

      {isValidUser && !loading ? (
        <>
          <div className="intro-bar-rfq">
            <div className="int-left-rfq">
              <div
                className="left-item"
                style={{ marginRight: "40px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              >
                <img src={backImg} height="15px" />
              </div>

              <div className="left-item">
                <p className="p-header">
                  RFQ ID : {selectedRFQ.supplierRFQRefId}
                </p>
                <p
                  className={
                    selectedRFQ.status == "Pending for Quotation"
                      ? "pending-for-quotation"
                      : selectedRFQ.status == "Under Review"
                        ? "under-review"
                        : selectedRFQ.status == "Unapproved"
                          ? "unapproved-quotes"
                          : ""
                  }
                >
                  {selectedRFQ.status}
                </p>
              </div>

              <div className="left-item">
                <p className="p-header">REQUESTED DATE</p>
                <p>{moment(selectedRFQ.receivedDate).format("DD MMM YYYY")}</p>
              </div>
            </div>
            <div className="int-right-rfq">
              {selectedRFQ.status !== "Under Review" && (
                <div
                  className="right-item"
                  onClick={() => setShowDeclineModal(true)}
                >
                  <button
                    className="white-btn"
                    style={{
                      color: "red",
                      fontWeight: "500",
                      marginRight: "0px",
                      width: "177px",
                      padding: "10px",
                    }}
                  >
                    Decline Quotation
                  </button>
                </div>
              )}
              {selectedRFQ.status == "Pending for Quotation" ? (
                <>
                  <div className="right-item">
                    <button
                      className="chat-btn"
                      style={{
                        color: "white",
                        fontWeight: "500",
                        backgroundColor: isSubmitQuoteLoading ? "#999" : "#00c389",
                        cursor: isSubmitQuoteLoading ? "not-allowed" : "pointer",
                      }}
                      onClick={() => {
                        if (isSubmitQuoteLoading) return;
                        const isValidData = validateRFQData();
                        if (isValidData) {
                          setShowReviewQuoteModal(true);
                        } else {
                          toast.error("Item price and delivery date are required fields.");
                        }
                      }}
                      disabled={isSubmitQuoteLoading}
                    >
                      {isSubmitQuoteLoading ? "Processing..." : "Submit Quotation"}
                    </button>

                  </div>
                </>
              ) : (
                <></>
              )}

              <div className="right-item">
                <button
                  className=" px-2  py-2 bg-primaryColor h-10 rounded flex items-center justify-center "
                  onClick={showDrawer}
                >
                  <ChatButton
                    color={"white"}
                    RefId={selectedRFQ.supplierRFQRefId}
                    showDrawer={showDrawer}
                    additionalClasses={"text-white text-sm h-10"}
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-holder ">
            <div className="lg-container -translate-y-10">
              {/* <Chat RefId={RefId} open={open} onDrawerClose={onClose} /> */}
              <div className="common-bx">
                <div
                  className={
                    selectedRFQ.status == "Under Review"
                      ? "process-bar-bx green-line"
                      : "process-bar-bx grey-line"
                  }
                >
                  <span className="process-ico green-fill">
                    <img src={settingw} />
                  </span>
                  <div
                    style={{
                      maxWidth: "500px",
                      wordWrap: "break-word",
                      wordBreak: "break-all",
                      whiteSpace: "normal",
                      position: "absolute",
                      right: "150px",
                    }}
                  >
                    <span
                      className="text"
                      style={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "bolder",
                      }}
                    >
                      Project Name
                    </span>
                    <div
                      className="name"
                      style={{ color: "#000", fontSize: "14px" }}
                    >
                      {selectedRFQ?.rfqOfferId?.projectName || "Not Found"}
                    </div>
                  </div>
                  <h5>Requirements</h5>
                  <p style={{ color: "#333333", fontSize: "12px" }}>
                    {moment(selectedRFQ.createdAt).format("DD MMM YYYY")}
                  </p>
                  <div className="flex items-center justify-between ">
                    <h6
                      className="box-in-quote-version"
                      style={{ color: "#333333" }}
                    >
                      MFG. Process :{" "}
                      {selectedRFQ?.rfqOfferId?.selectedProcess
                        ? processType[selectedRFQ?.rfqOfferId?.selectedProcess - 1]
                          .name
                        : null}
                    </h6>
                    <div className="flex items-center justify-end">
                      <button onClick={handleBatchDownloadClick} className="rounded px-3 py-2 border flex items-center justify-center gap-x-2 " >
                        <span>Batch download all technical drawings</span>
                        <DownloadIcon />
                      </button>
                    </div>
                  </div>
                  <div className="version-tabs overflow-x-auto" >
                    <table className="qoute-version-table">
                      <thead>
                        <tr className="heading-row">
                          <th scope="col" >Snapshot</th>
                          <th scope="col" >Files</th>
                          <th scope="col" >Description</th>
                          <th scope="col" >Notes</th>
                          <th scope="col" >Unit Price</th>
                          <th scope="col" >Qty</th>
                          <th scope="col" >Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRFQ?.partsData?.length > 0 &&
                          selectedRFQ.partsData.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td style={{ minWidth: "150px" }} className="">
                                  <p className="text-sm bold text-center  h-28 ">
                                    <ThreeDViewerComponent
                                      item={item}
                                      selectedProcess={selectedRFQ?.rfqOfferId?.selectedProcess}
                                      additionalClasses={'!border-0'}

                                    />
                                  </p>
                                </td>

                                <td
                                  style={{ minWidth: "250px" }}
                                >

                                  <p className="text-primaryColor">
                                    {item.selectedFile?.originalname ? (
                                      <>
                                        <FileName fileName={item.selectedFile?.originalname} onDownload={async () => {
                                          const { originalname } = item?.selectedFile;
                                          if (originalname && originalname.endsWith('.pdf')) {
                                            const signedUrl = await getPresignedUrlForFile(item?.selectedFile.bucket, item?.selectedFile.key);
                                            console.log('Signed URL for PDF:', signedUrl);
                                            setPdfModalInfo({
                                              show: true,
                                              pdfUrl: signedUrl,
                                              fileName: originalname,
                                            })
                                            return;
                                          }
                                          await downloadFileFromS3(item?.selectedFile)
                                        }} />
                                        <DimensionsDisplay
                                          item={item}
                                        />
                                      </>
                                    ) : (
                                      "File Not Available"
                                    )}

                                  </p>

                                  <p className="text-primaryColor">
                                    {item.twoDFile?.originalname ? (
                                      <>
                                        <FileName
                                          fileName={item.twoDFile?.originalname}
                                          onDownload={async () => {
                                            const { originalname } = item?.twoDFile;
                                            if (originalname && originalname.endsWith('.pdf')) {
                                              const signedUrl = await getPresignedUrlForFile(item?.twoDFile.bucket, item?.twoDFile.key);
                                              console.log('Signed URL for PDF:', signedUrl);
                                              setPdfModalInfo({
                                                show: true,
                                                pdfUrl: signedUrl,
                                                fileName: originalname,
                                              })
                                              return;
                                            }
                                            await downloadFileFromS3(item?.twoDFile)
                                          }}
                                        />
                                        <DimensionsDisplay
                                          item={item}
                                        />
                                      </>
                                    ) : (
                                      "File Not Available"
                                    )}
                                  </p>
                                </td>
                                <td style={{ minWidth: "250px" }}>
                                  {selectedRFQ?.rfqOfferId?.selectedProcess >= 3 ? (
                                    <>{item.description}</>
                                  ) : (
                                    <div >
                                      {
                                        selectedRFQ?.rfqOfferId?.selectedProcess == 1 ?
                                          <MetaDataCncComponent allData={allData} item={item} /> : null
                                      }
                                      {
                                        selectedRFQ?.rfqOfferId?.selectedProcess == 2 ?
                                          <MetaDataThreeDComponent masterThreeDTechnologyData={masterThreeDTechnologyData} item={item} /> : null
                                      }

                                    </div>
                                  )}
                                </td>
                                <td style={{ minWidth: "150px" }}>
                                  <textarea
                                    className="border p-1"
                                    placeholder="Enter notes here"
                                    style={{ width: "100%", height: "100px" }}
                                    value={item?.notes}
                                    onChange={(e) =>
                                      handleItemNotesChage(e, index)
                                    }
                                    maxLength={200}
                                    disabled={
                                      handleRfqDisableState()
                                    }
                                  />
                                </td>
                                <td style={{ minWidth: '100px' }}>
                                  <div className="flex justify-center gap-x-2">
                                    <input
                                      className="border grow p-1 w-full"
                                      placeholder="Enter price"
                                      value={item.price ? item.price : ""}
                                      style={{
                                        width: "60px",
                                        marginBottom: "15px",
                                      }}
                                      onWheel={numberInputOnWheelPreventChange}
                                      onKeyDown={(e) =>
                                        ["e", "E", "+", "-"].includes(e.key) &&
                                        e.preventDefault()
                                      }
                                      onChange={(e) => {
                                        handleItemPriceChange(e, index);
                                      }}
                                      disabled={
                                        handleRfqDisableState()
                                      }
                                    />
                                  </div>
                                </td>
                                <td style={{ minWidth: "80px" }}>
                                  <p className="amt text-center">{item?.qty}</p>
                                </td>
                                <td style={{ minWidth: "100px" }}>
                                  <div className="amt">
                                    <p className="un-fld">
                                      <CurrencyFormat
                                        amount={
                                          item.qty * item.price
                                        }
                                      />
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-3  flex justify-end ">
                    <div>
                      <div className="flex items-center gap-x-2 justify-center ">
                        <div className="grow">
                          <p
                            style={{
                              color: "#333333",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            Lead Time (in Days):
                          </p>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              marginTop: "-10px",
                            }}
                          >
                            <div
                              className="apply-check"
                              style={{ marginRight: "80px" }}
                            >
                              <input
                                className="border p-1"
                                type="number"
                                style={{ fontSize: "13px" }}
                                onWheel={numberInputOnWheelPreventChange}
                                onKeyDown={(e) =>
                                  ["e", "E", "+", "-"].includes(e.key) &&
                                  e.preventDefault()
                                }
                                onChange={handleLeadTimeChange}
                                disabled={
                                  handleRfqDisableState()
                                }
                                placeholder="Lead time in Days"
                                value={
                                  selectedRFQ.leadTime
                                    ? selectedRFQ.leadTime
                                    : ""
                                }
                              />
                              {selectedRFQ.leadTime ? (
                                <div style={{ fontSize: "13px" }}>
                                  ({selectedRFQ.leadTime} business days)
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="total-amount-order  grow w-[180px]  ">
                          <h6 className="order-price h-10 flex items-center gap-x-2 ">
                            <div> Total : </div>
                            <div >
                              {selectedRFQ.price ? (
                                <CurrencyFormat
                                  amount={Number(selectedRFQ.price).toFixed(2)}
                                />
                              ) : (
                                "0"
                              )}
                            </div>
                          </h6>
                        </div>
                      </div>
                      <div>
                        {!handleRfqDisableState() && (
                          <div>
                            <button
                              className=" px-3 py-2 mt-4  float-end rounded flex justify-center items-center"
                              style={{
                                color: "white",
                                fontWeight: "500",
                                backgroundColor: "#00c389",
                                width: "100%",
                              }}
                              onClick={() => {
                                const isValidData = validateRFQData();
                                if (isValidData) {
                                  setShowReviewQuoteModal(true);
                                } else {
                                  toast.error(
                                    "Item price and delivery date are required field."
                                  );
                                }
                              }}
                            >
                              {
                                selectedRFQ.status == "Under Review" ? "Update Quotation" : "Submit Quotation"
                              }
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="order-pay-box">
                  <span className="order-ico">
                    <img src={docGrey} />
                  </span>
                  <h5>Order Details</h5>
                  {selectedRFQ.status == "Under Review" ? (
                    <div
                      style={{
                        background: "#DEE2E6",
                        padding: "20px 30px",
                        borderRadius: "5px",
                        fontSize: "14px",
                      }}
                    >
                      <h6>Your quote is under review.</h6>
                      <p>
                        Your quotation has been submitted successfully. If your
                        quote is accepted, we will send you a Purchase Order
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          <div className="dashboard-holder">
            <div className="sm-container">
              <div className="dashboard-option">
                <div className="dash-left">
                  <div className="ds-heading">
                    <Link to="/dashboard">
                      <p className="req-quote-btn">Go To DashBoard </p>
                    </Link>
                  </div>
                </div>

                <div style={{ textAlign: "center" }}>
                  <h2>Quotation information is not available</h2>
                  <br />
                  <p>Your dont have access to this quote version details.</p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RFQDetails;
